import React, { useEffect, useState } from 'react';
import { Alert } from 'react-bootstrap';
import api from '../../api/apiClient';

const UserPrivacyPage = () => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [policy, setPolicy] = useState(null);

  useEffect(() => {
    const fetchPrivacy = async () => {
      try {
        setLoading(true);
        setError(null);
        const response = await api.privacy.getCurrent();
        if (response.data?.success) {
          setPolicy(response.data.data || null);
        } else {
          setError(response.data?.message || 'Failed to load Privacy Policy');
        }
      } catch (err) {
        const message = err.response?.data?.message || err.message;
        setError(message || 'Failed to load Privacy Policy');
      } finally {
        setLoading(false);
      }
    };

    fetchPrivacy();
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-50 via-white to-indigo-50 p-4 sm:p-6 md:p-8 lg:p-10">
      <div className="bg-white/90 backdrop-blur-sm rounded-2xl sm:rounded-3xl border border-purple-100 shadow-xl p-6 sm:p-8 md:p-10">
        <div className="mb-6 sm:mb-8">
          <h1 className="text-2xl sm:text-3xl md:text-3xl font-bold text-gray-900 mb-2">Privacy Policy</h1>
          <div className="h-1 w-20 bg-gradient-to-r from-purple-600 to-pink-600 rounded-full"></div>
        </div>

        {loading && (
          <div className="text-center py-12">
            <div className="animate-spin rounded-full h-12 w-12 border-4 border-purple-600 border-t-transparent mx-auto mb-4"></div>
            <p className="text-gray-600 font-medium">Loading Privacy Policy...</p>
          </div>
        )}

        {error && !loading && (
          <Alert variant="danger" className="rounded-xl border-2 border-red-200 bg-red-50 text-red-800 font-medium py-4">
            <strong>Error:</strong> {error}
          </Alert>
        )}

        {!loading && !error && !policy && (
          <div className="text-center py-12">
            <div className="bg-gray-100 rounded-full w-20 h-20 flex items-center justify-center mx-auto mb-4">
              <i className="fas fa-shield-alt text-3xl text-gray-400"></i>
            </div>
            <p className="text-gray-600 font-medium text-lg">
              No Privacy Policy has been published yet.
            </p>
          </div>
        )}

        {!loading && !error && policy && (
          <>
            <div className="bg-gradient-to-r from-purple-50 to-indigo-50 rounded-xl p-4 mb-6 border border-purple-200">
              <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2">
                <div>
                  <span className="text-sm font-semibold text-purple-700">Version {policy.version}</span>
                </div>
                {policy.published_at && (
                  <div className="text-sm text-gray-600">
                    <i className="far fa-calendar-alt mr-2"></i>
                    Published on {new Date(policy.published_at).toLocaleDateString('en-US', { 
                      year: 'numeric', 
                      month: 'long', 
                      day: 'numeric' 
                    })}
                  </div>
                )}
              </div>
            </div>
            <div 
              className="prose prose-purple max-w-none text-gray-700 leading-relaxed"
              dangerouslySetInnerHTML={{ __html: policy.content || '' }}
              style={{
                fontSize: '16px',
                lineHeight: '1.8'
              }}
            />
          </>
        )}
      </div>
    </div>
  );
};

export default UserPrivacyPage;
